'use client';

/* eslint-disable react/function-component-definition, @typescript-eslint/consistent-type-definitions */

import { ReactNode } from 'react';
import { useMonarchData } from '../../../components/ui/organisms/monarch/MonarchResolver';
import { MonarchTestResult } from './types';

interface MonarchDataConsumerProps<TResult extends MonarchTestResult> {
  children: (data: TResult) => ReactNode;
  // Require experiment key to identify which experiment data to use
  experimentKey: string;
}

/**
 * Consumes data for a specific Monarch experiment and passes it to its children.
 */
export function MonarchDataConsumer<TResult extends MonarchTestResult>({
  children,
  experimentKey,
}: MonarchDataConsumerProps<TResult>) {
  // Get data for the specific experiment directly
  const dataToProvide = useMonarchData<TResult>(experimentKey);
  if (!dataToProvide) {
    return <>{children({} as TResult)}</>;
  }

  return <>{children(dataToProvide as TResult)}</>;
}
